import React, {createContext, useContext} from 'react';
import {Config, Recommendation, Track} from 'qon-connection';
import readConfig from '../utils/readClientConfiguration';
import appConfiguration from '../config/default.json';

const QuarticonContext = createContext(null);

export const useQuarticonContext = () => {
    return useContext(QuarticonContext);
};

export const QuarticonContextProvider = ({children}) => {

    const quarticonConfig = readConfig(appConfiguration, 'quarticon');
    const hasMarketingConsent =
        typeof window !== 'undefined' &&
        window.Cookiebot &&
        window.Cookiebot.consent &&
        window.Cookiebot.consent.marketing;

    let tracker = null;
    let recommendationEngine = null;

    if (hasMarketingConsent && quarticonConfig?.is_active) {
        const config = new Config.Config({
            customerSymbol: quarticonConfig.customer_symbol,
            host: quarticonConfig.host_url,
        });
        tracker = new Track.Tracker(config);
        recommendationEngine = new Recommendation.Recommendation(config);
    }

    return (
        <QuarticonContext.Provider
            value={{
                tracker,
                recommendationEngine,
            }}
        >
            {children}
        </QuarticonContext.Provider>
    );
};
